import request from "@/axios";
/** 分页查询媒资内容管理接口 */
export const getList = params => {
  return request({
    url: `/lebo-vod/vod/media/page`,
    method: "get",
    params: params
  });
};
/** 获取媒资来源接口 */
export const getSource = () => {
  return request({
    url: `/lebo-vod/vod/partner/list`,
    method: "get"
  });
};
/** 获取媒资内容详情的接口 */
export const getDetail = id => {
  return request({
    url: `/lebo-vod/vod/media/getById`,
    method: "get",
    params: {
      id
    }
  });
};
/** 媒资管理修改状态的接口 */
export const changeStatus = params => {
  return request({
    url: `/lebo-vod/vod/media/updateStatusById`,
    method: "get",
    params
  });
};

/** 媒资管理上线 */
export const mediaPutOnApi = params => {
  return request({
    url: `/lebo-vod/vod/media/putOn`,
    method: "get",
    params
  });
};


/** 媒资管理下线 */
export const mediaTakeOffApi = params => {
  return request({
    url: `/lebo-vod/vod/media/takeOff`,
    method: "get",
    params
  });
};

/** 分集详情修改状态 */
export const changeEpisodeStatus = params => {
  return request({
    url: `/lebo-vod/vod/media/updateEpisodeStatusByEpisodeId`,
    method: "get",
    params
  });
};
/** 片花详情修改状态 */
export const changeTrailerStatus = params => {
  return request({
    url: `/lebo-vod/vod/media/updateTrailerStatusByTrailerId`,
    method: "get",
    params
  });
};
/** 重置分集排序 */
export const resetEpisodeSort = data => {
  return request({
    url: `/lebo-vod/vod/media/resetEpisodeSort`,
    method: "post",
    data
  });
};
/** 重置片花排序 */
export const resetTrailerSort = data => {
  return request({
    url: `/lebo-vod/vod/media/resetTrailerSort`,
    method: "post",
    data
  });
};

/** 更新数据的接口 */
export const updateData = () => {
  return request({
    url: `/lebo-vod/vod/media/syncMedia`,
    method: "get"
  });
};

/** 获取日志的接口 */
export const getLog = params => {
  return request({
    url: `/lebo-vod/vod/media/syncLog/page`,
    method: "get",
    params
  });
};


/** 新增媒资 */
export const mediaSaveApi = data => {
  return request({
    url: `/lebo-vod/vod/media/save`,
    method: "post",
    data: data
  });
};

/** 新增媒资 */
export const mediaUpdateApi = data => {
  return request({
    url: `/lebo-vod/vod/media/update`,
    method: "post",
    data: data
  });
};

/** 新增分集 */
export const mediaEpisodeApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode`,
    method: "post",
    data: data
  });
};


/** 获取视频时长，单位秒 */
export const analysisDurationApi = params => {
  return request({
    url: `/lebo-vod/vod/media/analysis/duration`,
    method: "get",
    params
  });
};

/** 修改分集 */
export const mediaEpisodeEditApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode`,
    method: "PUT",
    data: data
  });
};


/** 重置排序分集 */
export const mediaEpisodeResetSortApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode/resetSort`,
    method: "post",
    data: data
  });
};


/** 上线分集 */
export const mediaEpisodePutOnApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode/put-on/` + data.id,
    method: "PUT",
    data: data
  });
};

/** 下线分集 */
export const mediaEpisodeTakeOffApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode/take-off/` + data.id,
    method: "PUT",
    data: data
  });
};


/** 删除分集 */
export const mediaEpisodeDeleteApi = data => {
  return request({
    url: `/lebo-vod/vod/media-episode/` + data.id,
    method: "DELETE",
    data: data
  });
};



/** 新增片花 */
export const addMediaTrailerApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer`,
    method: "post",
    data: data
  });
};



/** 修改片花 */
export const editMediaTrailerApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer`,
    method: "PUT",
    data: data
  });
};


/** 上线片花 */
export const trailerPutOnApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer/put-on/` + data.id,
    method: "PUT",
    data: data
  });
};

/** 下线片花 */
export const trailerTakeOffApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer/take-off/` + data.id,
    method: "PUT",
    data: data
  });
};

/** 重置排序片花 */
export const trailerResetSortApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer/resetSort`,
    method: "post",
    data: data
  });
};


/** 删除片花 */
export const trailerDeleteApi = data => {
  return request({
    url: `/lebo-vod/vod/media-trailer/` + data.id,
    method: "DELETE",
    data: data
  });
};

/** 删除媒资 */
export const mediaDeleteApi = data => {
  return request({
    url: `/lebo-vod/vod/media/delById`,
    method: "get",
    params: data
  });
};

// 分页查询操作日志
export const logPageApi = data => {
  return request({
    url: `/lebo-vod/vod/log/page`,
    method: "get",
    params: data
  });
};
// 新增定价价格
export const addPriceApi = data => {
  return request({
    url: `/lebo-vod/vod/mediaPrice/save`,
    method: "post",
    data: data
  });
};
// 编辑定价价格
export const editPriceApi = data => {
  return request({
    url: `/lebo-vod/vod/mediaPrice/update`,
    method: "post",
    data: data
  });
};
// 删除定价
export const deletePriceApi = id => {
  return request({
    url: `/lebo-vod/vod/mediaPrice/delById`,
    method: "get",
    params: {
      id
    }
  });
};
